import { truncateNameWithDot, uppercaseFirstCharInText } from '@sky-it-livedata-libraries/livedata-commons';

/**
 * Return complete name of the driver
 * @param customDriverSurname Driver Surname
 * @param customDriverName Driver Name
 */
export const getDriverName = (customDriverSurname: string, customDriverName: string): string =>
  `${truncateNameWithDot(customDriverName.toUpperCase())} ${uppercaseFirstCharInText(customDriverSurname)}`;
